import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { Cropper, CircleStencil } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
import { ProfileColorEnum } from "../../../enums/ChatUserProfileEnum";
import { MessageService } from "../../../services/message-service";
import { EMPTY_GUID } from "../../../common/utilities/empty-guid";
import { mapActions } from "pinia";
import { useUserStore } from "../../../pages-vue/MessageCenter/store/useUsersStore";

export default defineComponent({
    inject: ["dialogRef"],

    components: {
        Cropper,
        CircleStencil
    },

    data() {
        return {
            _messageService: null as MessageService,
            dialogReference: this.dialogRef as any,
            options: {},
            userInitials: "" as string,
            prevPicId: null as string,
            profilePic: null,
            profileColor: ProfileColorEnum.Crimson as ProfileColorEnum,
            uploadImage: null,
            finalFile: null,
            showCropper: false
        };
    },

    async mounted() {
        this._messageService = Container.instance.get(MessageService);
        this.profileColor = this.dialogReference.data.profileColor;
        this.userInitials = this.dialogReference.data.userInitials;
        const id = this.dialogReference.data.currentProfilePic;
        const loginId = this.dialogReference.data.loginId;
        if (id && id !== EMPTY_GUID) {
            this.prevPicId = id;
            this.profilePic = await this.fetchImage(loginId, id);
        }
    },

    computed: {
        CircleStencil() {
            return CircleStencil;
        }
    },

    methods: {
        ...mapActions(useUserStore, ["fetchImage"]),

        openUploader() {
            (this.$refs.fileInput as any).click();
        },

        onFileChange(e) {
            const file = e.target.files[0];
            if (!file) return;

            this.uploadImage = URL.createObjectURL(file);
            this.showCropper = true;
        },

        cancelCrop() {
            this.showCropper = false;
            this.uploadImage = null;
        },

        saveCropped() {
            const cropper = this.$refs.cropperRef;
            const result = (cropper as any).getResult();

            if (!result || !result.canvas) return;
            // Original cropped canvas
            const originalCanvas = result.canvas;

            // Resized canvas to reduce file size for faster loading and save storage for backend
            const resizedCanvas = document.createElement("canvas");
            const width = 256;
            const height = 256;

            resizedCanvas.width = width;
            resizedCanvas.height = height;

            const ctx = resizedCanvas.getContext("2d");

            // Draw original cropped output onto new canvas (resized)
            ctx.drawImage(originalCanvas, 0, 0, width, height);

            // Export resized PNG
            resizedCanvas.toBlob((blob: any) => {
                if (!blob) return;
                const fileName = "profile_" + Date.now() + ".png";
                // convert blob to png file
                const file = new File([blob], fileName, { type: "image/png" });
                const url = URL.createObjectURL(file);
                this.finalFile = [file];
                this.profilePic = url;
                this.showCropper = false;
            }, "image/png");
        },

        removeProfilePic() {
            this.profilePic = null;
        },

        async saveProfilePic() {
            let assetDetails: any;
            if (this.finalFile) {
                const asset = await this._messageService.uploadMessageFiles(this.finalFile);
                assetDetails = asset[0].assetId;
            } else if (this.profilePic === null) {
                assetDetails = EMPTY_GUID;
            } else {
                assetDetails = this.prevPicId;
            }
            this.dialogReference.close({
                status: "success",
                assetId: assetDetails
            });
        },

        closeDialog() {
            this.dialogReference.close();
        }
    }
});
